import _extends from 'babel-runtime/helpers/extends';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import Tick from '@wh/svg-icons/Tick';

import { getAllowedAttributes } from '../props-filters';
import propTypeClassName from '../propTypeClassName';

import { KEYCODES } from './helpers';

import * as style from './SelectOptionInternal.style';

var SelectOptionInternal = function (_PureComponent) {
  _inherits(SelectOptionInternal, _PureComponent);

  function SelectOptionInternal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectOptionInternal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectOptionInternal.__proto__ || _Object$getPrototypeOf(SelectOptionInternal)).call.apply(_ref, [this].concat(args))), _this), _this.focusOption = function () {
      if (_this.props.focus) _this.node.focus();
    }, _this.storeOptionRef = function (node) {
      _this.node = node;
    }, _this.requestSelect = function (e) {
      if (_this.props.onSelectRequest) _this.props.onSelectRequest(e);
    }, _this.handleOnClick = function (e) {
      _this.requestSelect(e);
    }, _this.handleOnKeyDown = function (e) {
      var keyCode = e.keyCode;

      if (keyCode === KEYCODES.ENTER || keyCode === KEYCODES.SPACE) {
        _this.requestSelect(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectOptionInternal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusOption();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.focusOption();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          selected = _props.selected,
          size = _props.size,
          children = _props.children;
      var selectOption = style.selectOption,
          selectOptionSelected = style.selectOptionSelected,
          selectTick = style.selectTick;


      var classNames = cx(selectOption(size), _defineProperty({}, selectOptionSelected, selected), className);

      var allowedAttributes = getAllowedAttributes(this.props);

      return React.createElement(
        'div',
        _extends({
          ref: this.storeOptionRef,
          className: classNames,
          onClick: this.handleOnClick,
          onKeyDown: this.handleOnKeyDown,
          tabIndex: '-1'
        }, allowedAttributes, {
          role: 'listbox'
        }),
        React.createElement(
          'div',
          null,
          children
        ),
        selected && React.createElement(Tick, { className: selectTick })
      );
    }
  }]);

  return SelectOptionInternal;
}(PureComponent);

SelectOptionInternal.propTypes = {
  className: propTypeClassName,
  value: PropTypes.string,
  label: PropTypes.string,
  children: PropTypes.node,
  selected: PropTypes.bool,
  focus: PropTypes.bool,
  onSelectRequest: PropTypes.func,
  size: PropTypes.string.isRequired
};
SelectOptionInternal.defaultProps = {
  focus: false,
  selected: false,
  onSelectRequest: noop
};
export default SelectOptionInternal;